// @flow

import React from "react";

import Section from "../../components/Section";
import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import EditableField from "../../components/EditableField";

import { COLLATERALS } from "./formFields";
import * as formatters from "../../utils/formatters";
import styles from "../../components/EditableField/EditableField.scss";

type OkpCollateralInfoProps = {
  initialValues: {
    [COLLATERALS]: boolean
  },
  numberedWithDot?: boolean
};

const OkpCollateralInfo = ({ initialValues, numberedWithDot }: OkpCollateralInfoProps) => {
  const dumbValue = <span className={styles.dumbValue}>-</span>;

  return (
    <Section title="Sicherheiten" reducedMargin numberedWithDot={numberedWithDot}>
      <EditableForm initialValues={initialValues} isLocked>
        {initialValues[COLLATERALS]
          ? initialValues[COLLATERALS].map(({ kind, value }) => {
              return (
                <FormRow key={kind}>
                  <EditableField
                    fieldControlProps={{
                      name: COLLATERALS,
                      caption: () => "Bezeichnung"
                    }}
                    displayValue={() => kind || dumbValue}
                  />

                  <EditableField
                    fieldControlProps={{
                      name: COLLATERALS,
                      caption: () => "Betrag"
                    }}
                    displayValue={() => (value ? formatters.formatCurrency(value) : dumbValue)}
                  />

                  <div />
                </FormRow>
              );
            })
          : dumbValue}
      </EditableForm>
    </Section>
  );
};

OkpCollateralInfo.defaultProps = {
  numberedWithDot: false
};

export default OkpCollateralInfo;
